import React, { Component } from 'react';
import Nav from '../../components/nav/Nav';
import Footer from '../../components/footer/Footer';
import BaseMeta from '../../components/base-meta/BaseMeta';
import Loading from '../../components/loading-v2/LoadingV2';
import BlogLogo from '../../components/blog-logo/BlogLogo';
import PostBody from '../../components/post-body/PostBody';
import PostRelatedItem from '../../components/post-related-item/PostRelatedItem';
import PostFeaturedCarousel from '../../components/post-featured-carousel/PostFeaturedCarousel';
import ContentFooter from '../../components/content-footer/ContentFooter';
import { fetchOne } from '../../stores/BlogPostStore';
import styles from './BlogPost.css';

class BlogPost extends Component {
  componentDidMount() {
    const { title } = this.props.params;
    this.getPost(title);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.title !== this.props.params.title) {
      this.setState({ post: null, loadingAnimDone: false });
      this.getPost(nextProps.params.title);
    }
  }

  getPost(title) {
    fetchOne(title).then(post => this.setState({ post }));
  }

  state = {
    post: null,
    loadingAnimDone: false,
  };

  renderRelatedPosts(relatedPosts) {
    return (
      <div className={styles.relatedPosts}>
        {relatedPosts.length !== 0 && [
          <p
            className={styles.featuredArticleLabel}
            key="featured-articles-title"
          >
            Related Stories
          </p>,
          <div className="row" key="featured-articles-item">
            {relatedPosts.map((post, idx) => (
              <div className="col--s-3of12" key={`related-post-${idx}`}>
                <PostRelatedItem post={post} />
              </div>
            ))}
          </div>,
        ]}
      </div>
    );
  }

  render() {
    const { post } = this.state;

    if (post === null) {
      return (
        <BaseMeta
          path={this.props.location.pathname}
          title="Blog"
        >
          <Loading />
        </BaseMeta>
      );
    }

    if (!this.state.loadingAnimDone) {
      setTimeout(() => this.setState({ loadingAnimDone: true }), 500);
      return (
        <BaseMeta
          path={this.props.location.pathname}
          title="Blog"
        >
          <Loading hide />
        </BaseMeta>
      );
    }

    return (
      <main className={'animated fadeIn'}>
        <BaseMeta
          path={this.props.location.pathname}
          title={post.title}
          description={post.extract}
          imageUrl={post.listImg ? post.listImg.url : null}
          imageType={post.listImg ? post.listImg.type : null}
          imageWidth={post.listImg ? post.listImg.width : null}
          imageHeight={post.listImg ? post.listImg.height : null}
        />
        <Nav activeItem="blog" />
        <section className="container">
          <BlogLogo />
          <p className={styles.postTitle}>{post.title}</p>
          <PostFeaturedCarousel
            imageUrls={post.featuredImgs.map(img => img.url)}
            title={post.title}
          />
          <div className="row">
            <div className="col--s-2of12" />
            <div className="col--s-8of12">
              <PostBody body={post.body} />
            </div>
          </div>
          <ContentFooter
            shareUrl={window.location.href}
          />
          {this.renderRelatedPosts(post.relatedPosts)}
        </section>
        <Footer />
      </main>
    );
  }
}

export default BlogPost;



// WEBPACK FOOTER //
// ./src/containers/blog-post/BlogPost.js